import React from "react";
import CloseIcon from "@mui/icons-material/Close";

import "./IframeContainer.css";

export default function IframeContainer({ src, handleCloseIcon }) {
  const isFullScreen = localStorage.getItem("openInFullScreen");
  var ChatBotOpenedHeight = document.getElementById('container')?.offsetHeight;
  var ChatBotOpenedWidth = document.getElementById('container')?.offsetWidth;
  var launchIocnHeight = document.getElementById('test-container')?.offsetHeight;
 
  var decideIframeHeight =()=>{
    
    return ChatBotOpenedHeight - launchIocnHeight + 40 ;
     
  }
  
 

  return (
    <div
      className={isFullScreen ? "showFullScreenIFrame" : "IframeContainer-in-app"}
      style={{
        width: ChatBotOpenedWidth,
        height: decideIframeHeight(),
        display:'flex',justifyContent:'center',alignItems:'center',
        position:'absolute',
        bottom:`${(launchIocnHeight/10) + 2}rem`,
        left:'1.5rem',
        zIndex:9999999999999
      }}
    >
      <div className={isFullScreen ?"close-icon-fs" :"close-icon"} onClick={() => handleCloseIcon()}>
        <CloseIcon height="3rem" width="3rem" />
      </div>
      <iframe
        id="s360-chat-iframe-inapp"
        name="s360chatiframe-inapp"
        frameborder="0"
        src={src}
        allowfullscreen="true"
        mozallowfullscreen="true"
        title="chatIframe"
        style={{ width: "98%", height: "95%", padding: "2%",display:'flex',justifyContent:'center',alignItems:'center' }}
      >
        {" "}
      </iframe>
    </div>
  );
}
